//# sourceMappingURL=combobox.mjs.map
/// <reference types="./combobox.d.mts" />
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $justin from "../../../justin/justin.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $event from "../../../redraw/redraw/event.mjs";
import * as $dom from "../../../redraw_dom/redraw/dom.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $keyboard from "../../../redraw_dom/redraw/dom/event/keyboard.mjs";
import * as $mouse from "../../../redraw_dom/redraw/dom/event/mouse.mjs";
import * as $events from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import * as $input from "../../ds/components/input.mjs";
import * as $cy from "../../ds/cypress.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $s from "../../ds/internals/styles/dropdown.mjs";
import * as $position from "../../ds/position.mjs";
import * as $popover from "../../ds/providers/popover.mjs";
import * as $scroll from "../../ds/providers/scroll.mjs";
import * as $utils from "../../ds/utils.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../gleam.mjs";

const FILEPATH = "src/ds/components/combobox.gleam";

class NoChoice extends $CustomType {}

class Section extends $CustomType {
  constructor(title, class$) {
    super();
    this.title = title;
    this.class = class$;
  }
}

class Choice extends $CustomType {
  constructor(title, icon, value, class$, mark_selected) {
    super();
    this.title = title;
    this.icon = icon;
    this.value = value;
    this.class = class$;
    this.mark_selected = mark_selected;
  }
}

export class Props extends $CustomType {
  constructor(on_selected, panel_position, label, placeholder, disabled, selected, icon, input_class, panel_class, stay_open, cypress) {
    super();
    this.on_selected = on_selected;
    this.panel_position = panel_position;
    this.label = label;
    this.placeholder = placeholder;
    this.disabled = disabled;
    this.selected = selected;
    this.icon = icon;
    this.input_class = input_class;
    this.panel_class = panel_class;
    this.stay_open = stay_open;
    this.cypress = cypress;
  }
}
export const Props$Props = (on_selected, panel_position, label, placeholder, disabled, selected, icon, input_class, panel_class, stay_open, cypress) =>
  new Props(on_selected,
  panel_position,
  label,
  placeholder,
  disabled,
  selected,
  icon,
  input_class,
  panel_class,
  stay_open,
  cypress);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$on_selected = (value) => value.on_selected;
export const Props$Props$0 = (value) => value.on_selected;
export const Props$Props$panel_position = (value) => value.panel_position;
export const Props$Props$1 = (value) => value.panel_position;
export const Props$Props$label = (value) => value.label;
export const Props$Props$2 = (value) => value.label;
export const Props$Props$placeholder = (value) => value.placeholder;
export const Props$Props$3 = (value) => value.placeholder;
export const Props$Props$disabled = (value) => value.disabled;
export const Props$Props$4 = (value) => value.disabled;
export const Props$Props$selected = (value) => value.selected;
export const Props$Props$5 = (value) => value.selected;
export const Props$Props$icon = (value) => value.icon;
export const Props$Props$6 = (value) => value.icon;
export const Props$Props$input_class = (value) => value.input_class;
export const Props$Props$7 = (value) => value.input_class;
export const Props$Props$panel_class = (value) => value.panel_class;
export const Props$Props$8 = (value) => value.panel_class;
export const Props$Props$stay_open = (value) => value.stay_open;
export const Props$Props$9 = (value) => value.stay_open;
export const Props$Props$cypress = (value) => value.cypress;
export const Props$Props$10 = (value) => value.cypress;

class State extends $CustomType {
  constructor(input, opened, parent_position, user_edited, current_highlight, open, close, set_input, on_user_input, get_next_current_highlight, get_previous_current_highlight) {
    super();
    this.input = input;
    this.opened = opened;
    this.parent_position = parent_position;
    this.user_edited = user_edited;
    this.current_highlight = current_highlight;
    this.open = open;
    this.close = close;
    this.set_input = set_input;
    this.on_user_input = on_user_input;
    this.get_next_current_highlight = get_next_current_highlight;
    this.get_previous_current_highlight = get_previous_current_highlight;
  }
}

class ContentProps extends $CustomType {
  constructor(props, state) {
    super();
    this.props = props;
    this.state = state;
  }
}

class ModalProps extends $CustomType {
  constructor(props, state, parent_position) {
    super();
    this.props = props;
    this.state = state;
    this.parent_position = parent_position;
  }
}

export function choice(title, value) {
  return new Choice(title, new None(), value, new None(), false);
}

export function section(title) {
  return new Section(title, new None());
}

export function no_choice() {
  return new NoChoice();
}

export function with_class(choice, class$) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    let title = choice.title;
    return new Section(title, new Some(class$));
  } else {
    let class$1 = new $option.Some(class$);
    return new Choice(
      choice.title,
      choice.icon,
      choice.value,
      class$1,
      choice.mark_selected,
    );
  }
}

export function with_icon(choice, icon) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    let icon$1 = new $option.Some(icon);
    return new Choice(
      choice.title,
      icon$1,
      choice.value,
      choice.class,
      choice.mark_selected,
    );
  }
}

export function mark_selected(choice, mark_selected) {
  if (choice instanceof NoChoice) {
    return choice;
  } else if (choice instanceof Section) {
    return choice;
  } else {
    return new Choice(
      choice.title,
      choice.icon,
      choice.value,
      choice.class,
      mark_selected,
    );
  }
}

export function on_selected(on_selected) {
  return new Props(
    on_selected,
    new $position.Left(),
    new None(),
    "Default placeholder",
    false,
    new None(),
    new None(),
    new None(),
    new None(),
    false,
    new None(),
  );
}

export function cy(props, value) {
  let cypress = new Some(value);
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    cypress,
  );
}

export function stay_open(props, stay_open) {
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    stay_open,
    props.cypress,
  );
}

export function on_selected_(handler) {
  return on_selected(
    (value) => {
      if (value instanceof Some) {
        let value$1 = value[0];
        return handler(value$1);
      } else {
        return undefined;
      }
    },
  );
}

export function panel_position(props, panel_position) {
  return new Props(
    props.on_selected,
    panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function label(props, label) {
  let label$1 = new Some(label);
  return new Props(
    props.on_selected,
    props.panel_position,
    label$1,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function placeholder(props, placeholder) {
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function disabled(props, disabled) {
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    disabled,
    props.selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function selected(props, selected) {
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    selected,
    props.icon,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function icon(props, icon) {
  let icon$1 = new Some(icon);
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    icon$1,
    props.input_class,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function input_class(props, input_class) {
  let input_class$1 = new Some(input_class);
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    input_class$1,
    props.panel_class,
    props.stay_open,
    props.cypress,
  );
}

export function panel_class(props, panel_class) {
  let panel_class$1 = new Some(panel_class);
  return new Props(
    props.on_selected,
    props.panel_position,
    props.label,
    props.placeholder,
    props.disabled,
    props.selected,
    props.icon,
    props.input_class,
    panel_class$1,
    props.stay_open,
    props.cypress,
  );
}

function on_toggle(props, state, scroll) {
  return $bool.lazy_guard(
    props.disabled,
    $a.none,
    () => {
      return $events.on_click(
        (event) => {
          let event$1 = $event.stop_propagation($mouse.as_event(event));
          let target = $event.target(event$1);
          return $bool.guard(
            state.opened,
            undefined,
            () => {
              let $ = $position.parent(target);
              if ($ instanceof Ok) {
                let parent_position = $[0];
                scroll.freeze();
                return state.open(parent_position);
              } else {
                return undefined;
              }
            },
          );
        },
      );
    },
  );
}

function get_choice_title(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let title = choice.title;
    return new Some(title);
  }
}

function get_choice_value(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let value = choice.value;
    return new Some(value);
  }
}

function get_choice(choices, value) {
  let _pipe = choices;
  let _pipe$1 = $list.find(
    _pipe,
    (c) => { return isEqual(get_choice_value(c), new Some(value)); },
  );
  return $option.from_result(_pipe$1);
}

function get_selected_title(choices, selected) {
  let _pipe = selected;
  let _pipe$1 = $option.then$(
    _pipe,
    (_capture) => { return get_choice(choices, _capture); },
  );
  let _pipe$2 = $option.then$(_pipe$1, get_choice_title);
  return $option.unwrap(_pipe$2, "");
}

/**
 * Make sure the `input` value is always in sync with `selected`.
 * - At mount, `input` is the selected title.
 * - At every `selected` change, update `input` with the new selected title.
 * - At every `choices` change, update `input` with the new selected title.
 * 
 * @ignore
 */
function use_selected_input_synced(choices, selected, set_input) {
  return ((_capture) => {
    return $redraw.use_effect(_capture, [choices, selected]);
  })(
    () => {
      let _pipe = get_selected_title(choices, selected);
      return set_input(_pipe);
    },
  );
}

function get_next_highlight(loop$choices, loop$highlight) {
  while (true) {
    let choices = loop$choices;
    let highlight = loop$highlight;
    if (choices instanceof $Empty) {
      return new Some(highlight);
    } else {
      let $ = choices.tail;
      if ($ instanceof $Empty) {
        let $1 = choices.head;
        if ($1 instanceof Choice) {
          let v1 = $1.value;
          if (isEqual(v1, highlight)) {
            return new Some(highlight);
          } else {
            let rest = $;
            loop$choices = rest;
            loop$highlight = highlight;
          }
        } else {
          return new None();
        }
      } else {
        let $1 = choices.head;
        if ($1 instanceof Choice) {
          let $2 = $.head;
          if ($2 instanceof Choice) {
            let v1 = $1.value;
            if (isEqual(v1, highlight)) {
              let v2 = $2.value;
              return new Some(v2);
            } else {
              let rest = $;
              loop$choices = rest;
              loop$highlight = highlight;
            }
          } else {
            let rest = $;
            loop$choices = rest;
            loop$highlight = highlight;
          }
        } else {
          return new None();
        }
      }
    }
  }
}

function get_next_highlight_choice(choices, current_highlight) {
  if (current_highlight instanceof Some) {
    let highlight = current_highlight[0];
    return get_next_highlight(choices, highlight);
  } else {
    let _pipe = $list.first(choices);
    let _pipe$1 = $option.from_result(_pipe);
    return $option.then$(_pipe$1, get_choice_value);
  }
}

/**
 * Setup the initial combobox state. When mounted, the Element gets the
 * initial selected item as input, is closed and has not been interacted with
 * the user.
 * 
 * @ignore
 */
function use_combobox_state(props, choices) {
  let $ = $redraw.use_lazy_state(
    () => { return get_selected_title(choices, props.selected); },
  );
  let input = $[0];
  let set_input = $[1];
  let $1 = $popover.use_opened();
  let opened = $1[0];
  let set_opened = $1[1];
  let $2 = $redraw.use_state(new None());
  let parent_position = $2[0];
  let set_parent_position = $2[1];
  let $3 = $redraw.use_state(false);
  let user_edited = $3[0];
  let set_user_edited = $3[1];
  let $4 = $redraw.use_state(new None());
  let current_highlight = $4[0];
  let set_current_highlight = $4[1];
  $redraw.use_effect(
    () => {
      return $bool.guard(
        opened,
        undefined,
        () => {
          set_user_edited(false);
          set_current_highlight(new None());
          set_parent_position(new None());
          let _pipe = get_selected_title(choices, props.selected);
          return set_input(_pipe);
        },
      );
    },
    [opened, choices, props.selected],
  );
  let open = ((_capture) => { return $redraw.use_callback(_capture, []); })(
    (parent_position) => {
      let parent_position$1 = new Some(parent_position);
      set_parent_position(parent_position$1);
      return set_opened(true);
    },
  );
  let on_user_input = ((_capture) => {
    return $redraw.use_callback(_capture, [opened]);
  })(
    (content) => {
      return $bool.guard(
        !opened,
        undefined,
        () => {
          set_input(content);
          set_user_edited(true);
          return set_current_highlight(new None());
        },
      );
    },
  );
  let get_next_current_highlight = ((_capture) => {
    return $redraw.use_callback(_capture, [current_highlight]);
  })(
    (choices) => {
      let _pipe = choices;
      let _pipe$1 = get_next_highlight_choice(_pipe, current_highlight);
      return set_current_highlight(_pipe$1);
    },
  );
  let get_previous_current_highlight = ((_capture) => {
    return $redraw.use_callback(_capture, [get_next_current_highlight]);
  })(
    (choices) => {
      let _pipe = choices;
      let _pipe$1 = $list.reverse(_pipe);
      return get_next_current_highlight(_pipe$1);
    },
  );
  let state = new State(
    input,
    opened,
    parent_position,
    user_edited,
    current_highlight,
    open,
    () => { return set_opened(false); },
    set_input,
    on_user_input,
    get_next_current_highlight,
    get_previous_current_highlight,
  );
  use_selected_input_synced(choices, props.selected, set_input);
  return state;
}

function view_icon(icon) {
  let _pipe = icon;
  let _pipe$1 = $option.map(_pipe, $s.full_icon_wrapper);
  return $option.lazy_unwrap(_pipe$1, $h.none);
}

function render_choice(props, option, highlighted, on_click) {
  let title;
  let icon$1;
  let value;
  let class$;
  let mark_selected$1;
  if (option instanceof Choice) {
    title = option.title;
    icon$1 = option.icon;
    value = option.value;
    class$ = option.class;
    mark_selected$1 = option.mark_selected;
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/components/combobox",
      660,
      "render_choice",
      "Pattern match failed, no pattern matched the value.",
      {
        value: option,
        start: 17964,
        end: 18037,
        pattern_start: 17975,
        pattern_end: 18028
      }
    )
  }
  let cy$1 = $cy.data($justin.kebab_case(title) + "-choice");
  let on_mousedown = $events.on_mouse_down(
    (event) => {
      let _pipe = event;
      let _pipe$1 = $mouse.as_event(_pipe);
      $event.prevent_default(_pipe$1);
      return undefined;
    },
  );
  let on_click$1 = $events.on_click((_) => { return on_click(); });
  return $s.choice_wrapper(
    class$,
    highlighted,
    toList([on_mousedown, on_click$1, cy$1]),
    toList([
      $s.choice_icon_wrapper(
        toList([]),
        toList([view_icon(icon$1), $h.text(title)]),
      ),
      (() => {
        let $ = mark_selected$1 || (isEqual(props.selected, new Some(value)));
        if ($) {
          return $s.icon_wrapper(toList([]), toList([$icons.checkmark()]));
        } else {
          return $h.none();
        }
      })(),
    ]),
  );
}

function user_selected_choice(props, choices, state, value) {
  let $ = props.stay_open;
  if ($) {
    state.set_input("");
    return props.on_selected(new Some(value));
  } else {
    state.close();
    let $1 = get_choice(choices, value);
    let $2 = props.selected;
    if ($1 instanceof Some) {
      if ($2 instanceof Some) {
        let sel = $2[0];
        if (!isEqual(sel, value)) {
          return props.on_selected(new Some(value));
        } else {
          let choice$1 = $1[0];
          let _pipe = get_choice_title(choice$1);
          let _pipe$1 = $option.unwrap(_pipe, "");
          return state.set_input(_pipe$1);
        }
      } else {
        return props.on_selected(new Some(value));
      }
    } else {
      return props.on_selected(new None());
    }
  }
}

function no_matching_choice() {
  return $s.no_choice(toList([]), toList([$h.text("No matching choice")]));
}

function do_remove_empty_sections(loop$choices, loop$return) {
  while (true) {
    let choices = loop$choices;
    let return$ = loop$return;
    if (choices instanceof $Empty) {
      return return$;
    } else {
      let $ = choices.tail;
      if ($ instanceof $Empty) {
        let $1 = choices.head;
        if ($1 instanceof Section) {
          return return$;
        } else {
          let fst = $1;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      } else {
        let $1 = choices.head;
        if ($1 instanceof Section) {
          let $2 = $.head;
          if ($2 instanceof Section) {
            let fst = $2;
            let rest = $.tail;
            loop$choices = listPrepend(fst, rest);
            loop$return = return$;
          } else {
            let fst = $1;
            let rest = $;
            loop$choices = rest;
            loop$return = listPrepend(fst, return$);
          }
        } else {
          let fst = $1;
          let rest = $;
          loop$choices = rest;
          loop$return = listPrepend(fst, return$);
        }
      }
    }
  }
}

function remove_empty_sections(choices) {
  return do_remove_empty_sections(choices, toList([]));
}

function keep_matching_title(choice, input) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return true;
  } else {
    let title = choice.title;
    let title$1 = $string.lowercase(title);
    let input$1 = $string.lowercase(input);
    return $string.contains(title$1, input$1);
  }
}

function keep_matching_choices(choices, state) {
  let no_filter = $string.is_empty(state.input);
  let default_display = !state.user_edited;
  return $bool.guard(
    no_filter || default_display,
    choices,
    () => {
      let _pipe = choices;
      let _pipe$1 = $list.filter(
        _pipe,
        (_capture) => { return keep_matching_title(_capture, state.input); },
      );
      let _pipe$2 = remove_empty_sections(_pipe$1);
      return $list.reverse(_pipe$2);
    },
  );
}

function portal_style(props, parent_position) {
  return $css.class$(
    toList([
      (() => {
        let _pipe = props.panel_class;
        let _pipe$1 = $option.map(_pipe, $css.compose);
        return $option.lazy_unwrap(_pipe$1, $css.none);
      })(),
      $css.position("fixed"),
      $css.width($length.px_(parent_position.right - parent_position.left)),
      $position.horizontal(parent_position, props.panel_position),
      $position.vertical(parent_position),
    ]),
  );
}

function combobox_modal() {
  return $redraw.component_(
    "Combobox(Modal)",
    (_use0) => {
      let props = _use0[0];
      let choices = _use0[1];
      let props$1 = props.props;
      let state = props.state;
      let parent_position = props.parent_position;
      let style = portal_style(props$1, parent_position);
      let choices$1 = keep_matching_choices(choices, state);
      let _pipe = $s.children_wrapper(
        style,
        toList([$utils.stop_propagation()]),
        (() => {
          let empty = $list.is_empty(choices$1);
          return $bool.lazy_guard(
            empty,
            () => { return toList([no_matching_choice()]); },
            () => {
              return $list.filter_map(
                choices$1,
                (choice) => {
                  if (choice instanceof NoChoice) {
                    return new Error(undefined);
                  } else if (choice instanceof Section) {
                    let title = choice.title;
                    let class$ = choice.class;
                    return new Ok(
                      $s.section_wrapper(
                        class$,
                        toList([]),
                        toList([$h.text(title)]),
                      ),
                    );
                  } else {
                    let v = choice.value;
                    let highlighted = isEqual(
                      new Some(v),
                      state.current_highlight
                    );
                    let on_sel = () => {
                      return user_selected_choice(props$1, choices$1, state, v);
                    };
                    return new Ok(
                      render_choice(props$1, choice, highlighted, on_sel),
                    );
                  }
                },
              );
            },
          );
        })(),
      );
      let _pipe$1 = $dom.create_portal(_pipe, "modal");
      return $result.lazy_unwrap(_pipe$1, $h.none);
    },
  );
}

function on_submit(props, choices, state) {
  let $ = state.current_highlight;
  if ($ instanceof Some) {
    let value = $[0];
    return user_selected_choice(props, choices, state, value);
  } else {
    return undefined;
  }
}

function get_choice_icon(choice) {
  if (choice instanceof NoChoice) {
    return new None();
  } else if (choice instanceof Section) {
    return new None();
  } else {
    let icon$1 = choice.icon;
    return icon$1;
  }
}

function combobox_icon(props, icon, content) {
  let _pipe = content;
  let _pipe$1 = $option.then$(_pipe, get_choice_icon);
  let _pipe$2 = $option.or(_pipe$1, icon);
  let _pipe$3 = $option.map(_pipe$2, $s.full_icon_wrapper);
  let _pipe$4 = $option.map(
    _pipe$3,
    (_capture) => { return $input.icon(props, _capture); },
  );
  return $option.unwrap(_pipe$4, props);
}

function submit_user_choice(props, choices, state, event) {
  let $ = state.current_highlight;
  let $1 = props.stay_open;
  if ($ instanceof Some) {
    if ($1) {
      let value = $[0];
      return user_selected_choice(props, choices, state, value);
    } else {
      let value = $[0];
      let _pipe = $keyboard.as_event(event);
      let _pipe$1 = $event.target(_pipe);
      $input.blur(_pipe$1);
      return user_selected_choice(props, choices, state, value);
    }
  } else {
    return undefined;
  }
}

function is_choice(choice) {
  if (choice instanceof NoChoice) {
    return false;
  } else if (choice instanceof Section) {
    return false;
  } else {
    return true;
  }
}

/**
 * Acts on `keydown`, only on `ArrowUp`, `ArrowDown` and `Enter` to edit
 * user highlights in the combobox modal. `on_keydown` being called on the
 * main `input`, combobox is opened and focused for the handler to work.
 * 
 * @ignore
 */
function on_keydown(props, choices, state, event) {
  let key = $keyboard.key(event);
  let keys = toList(["ArrowUp", "ArrowDown", "Enter"]);
  let is_valid_key = $list.contains(keys, key);
  return $bool.guard(
    !is_valid_key,
    undefined,
    () => {
      let _pipe = $keyboard.as_event(event);
      $event.prevent_default(_pipe);
      let _block;
      let _pipe$1 = keep_matching_choices(choices, state);
      _block = $list.filter(_pipe$1, is_choice);
      let choices$1 = _block;
      if (key === "ArrowDown") {
        return state.get_next_current_highlight(choices$1);
      } else if (key === "ArrowUp") {
        return state.get_previous_current_highlight(choices$1);
      } else if (key === "Enter") {
        return submit_user_choice(props, choices$1, state, event);
      } else {
        throw makeError(
          "panic",
          FILEPATH,
          "ds/components/combobox",
          384,
          "on_keydown",
          "Unreachable clause.",
          {}
        )
      }
    },
  );
}

function combobox_label() {
  return $redraw.component_(
    "Combobox(Label)",
    (_use0) => {
      let props = _use0[0];
      let choices = _use0[1];
      let content = $option.then$(
        props.props.selected,
        (_capture) => { return get_choice(choices, _capture); },
      );
      let on_keydown$1 = (_capture) => {
        return on_keydown(props.props, choices, props.state, _capture);
      };
      return $input.input(
        (() => {
          let _pipe = $input.value(props.state.input);
          let _pipe$1 = $input.disabled(_pipe, props.props.disabled);
          let _pipe$2 = $input.placeholder(_pipe$1, props.props.placeholder);
          let _pipe$3 = combobox_icon(_pipe$2, props.props.icon, content);
          let _pipe$4 = $input.on_input(_pipe$3, props.state.on_user_input);
          let _pipe$5 = $input.small(_pipe$4);
          let _pipe$6 = $input.on_keydown(_pipe$5, on_keydown$1);
          let _pipe$7 = $input.enter_submit(_pipe$6, true);
          return $input.on_submit(
            _pipe$7,
            () => { return on_submit(props.props, choices, props.state); },
          );
        })(),
      );
    },
  );
}

function combobox_content() {
  return $redraw.compose(
    combobox_label(),
    (combobox_label) => {
      return $redraw.compose(
        combobox_modal(),
        (combobox_modal) => {
          return $redraw.component_(
            "Combobox(Content)",
            (_use0) => {
              let props = _use0[0];
              let choices = _use0[1];
              return $s.full_wrapper(
                toList([]),
                toList([
                  combobox_label([props, choices]),
                  (() => {
                    let $ = props.state.opened;
                    let $1 = props.state.parent_position;
                    if ($) {
                      if ($1 instanceof Some) {
                        let parent_position = $1[0];
                        let props$1 = props.props;
                        let state = props.state;
                        let props$2 = new ModalProps(
                          props$1,
                          state,
                          parent_position,
                        );
                        return combobox_modal([props$2, choices]);
                      } else {
                        return $h.none();
                      }
                    } else {
                      return $h.none();
                    }
                  })(),
                ]),
              );
            },
          );
        },
      );
    },
  );
}

export function combobox() {
  return $redraw.compose(
    combobox_content(),
    (combobox_content) => {
      return $redraw.component_(
        "Combobox",
        (_use0) => {
          let props = _use0[0];
          let choices = _use0[1];
          let scroll = $scroll.use_scroll();
          let state = use_combobox_state(props, choices);
          let id = $redraw.use_id();
          let id$1 = $a.id("domrect-" + id);
          let rect_class = $a.class$($position.wrapper_class);
          let on_toggle$1 = on_toggle(props, state, scroll);
          let content = combobox_content(
            [new ContentProps(props, state), choices],
          );
          let _block;
          let _pipe = props.cypress;
          let _pipe$1 = $option.map(_pipe, $cy.data);
          _block = $option.lazy_unwrap(_pipe$1, $a.none);
          let cy_attr = _block;
          return $s.wrapper(
            props.disabled,
            props.input_class,
            toList([id$1, rect_class, on_toggle$1, cy_attr]),
            (() => {
              let $ = props.label;
              if ($ instanceof Some) {
                let label$1 = $[0];
                return toList([$h.text(label$1), content]);
              } else {
                return toList([content]);
              }
            })(),
          );
        },
      );
    },
  );
}
